import { gql } from '@apollo/client';

export const sendInvitationToPreRegistrantCohort_Name = 'SendInvitationToAllPreRegistrants';
export const sendInvitationToPreRegistrantCohort_Gql = gql`
  mutation SendInvitationToAllPreRegistrants($cohortId: String!) {
    sendInvitationToAllPreRegistrants(cohortId: $cohortId)
  }
`;
